import { resolverCircuitosParticipantesMes } from "./comisionEdificiosUtil";

/**
 * Explota contratos (sales_contratos) en objetos tipo factura filtrados por rango de fechas.
 * Misma estructura que las facturas de PAUTA para que el cálculo de comisión use el mismo util.
 */
export const explodarContratosComoFacturas = (contratos, edificiosMap, fechaInicio, fechaFin) => {
  const fechaInicioDate = new Date(fechaInicio);
  const fechaFinDate = new Date(fechaFin);
  const resultado = [];

  (contratos || [])
    .filter((c) => !c.eliminada && c.estatus === "100%")
    .forEach((c) => {
      (c.meses || []).forEach((mesObj, mesIndex) => {
        if (!mesObj.facturafecha) return;
        const fecha = new Date(mesObj.facturafecha);
        if (isNaN(fecha.getTime())) return;
        if (fecha < fechaInicioDate || fecha > fechaFinDate) return;

        // Circuitos + participantes por la FUENTE ÚNICA (regla 10.1) — la MISMA que usa la captura del
        // snapshot, así el denominador vivo y el congelado no pueden divergir.
        const { pAsc, pEsp, pCir, pCow, edificiosParticipantes, vacio } = resolverCircuitosParticipantesMes(
          mesObj,
          edificiosMap
        );
        if (vacio) return;

        let pantallasTotales = Number(mesObj.pantallas_totales) || 0;
        if (!pantallasTotales) {
          const sumPantallas = (csv, key) =>
            (csv || "")
              .split(",")
              .map((s) => Number(s.trim()))
              .filter(Boolean)
              .reduce((acc, eid) => acc + (Number(edificiosMap[eid]?.[key]) || 0), 0);
          pantallasTotales =
            sumPantallas(pAsc, "pantallas") +
            sumPantallas(pCir, "totems") +
            sumPantallas(pEsp, "espera") +
            sumPantallas(pCow, "cowork");
        }

        resultado.push({
          id: `contrato-${c.id}-${mesObj.mes}`,
          // Conector con la vinculación SII (venta_tipo='sales_contratos', venta_ref_index=índice
          // del mes en meses[]). Usado para resolver la cobranza real por mes (getCobroReal).
          contrato_id: c.id,
          mes_index: mesIndex,
          facturanumero: mesObj.facturanumero || c.display_id || `CT-${c.id}`,
          facturafecha: mesObj.facturafecha,
          facturafechacobro: mesObj.facturafechacobro || null,
          importe: Number(mesObj.importe) || 0,
          client_id: c.client_id,
          // Acuerdos a nivel CONTRATO (aplican a todos sus meses): APX (capa aditiva) y override de
          // volumen. Necesarios para que getApxMonto / calcularImporteNetoIntermediario los resuelvan
          // en las superficies de comisión edificios (getSaldoEdificio, ledger, Calculador). Gating por
          // apx_id (sin apx_id → getApxMonto=0). Espejo del fix de contratos en el ER (b631720).
          apx_id: c.apx_id,
          descuento_acuerdo_pct: c.descuento_acuerdo_pct,
          moneda_dolar: c.moneda_dolar || false,
          pais: c.pais,
          edificiosparticipantes: edificiosParticipantes,
          pantallastotales: pantallasTotales,
          pantallas_ascensores: pAsc,
          pantallas_espera: pEsp,
          pantallas_circulacion: pCir,
          pantallas_cowork: pCow,
          isBTL: false,
          isContrato: true,
          eliminada: false,
        });
      });
    });

  return resultado;
};
